module.exports = __webpack_public_path__ + "static/media/lea_img_05.08318d8a.jpg";